module.exports = __webpack_public_path__ + "img/hot-flashes.8e0a9a58.svg";